"use strict";
// A clinician as every screen, filter and workbook names it (QB3 item 10, J-273): "Name (NPI)", or the
// NPI alone when no name is known. The name comes from the ACO-MS Provider/Supplier List (F6,
// `ref.aco_provider_supplier`) for the ACO, TIN and NPI, else from the year's loaded bundle's clinician
// line (`core.bundle_clinician`, named by NPPES or the registry). Standard library only: the server's
// workbooks and the web screens both call it. NPIs and names are provider identifiers, never patient data.
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferredClinicianName = preferredClinicianName;
exports.clinicianLabel = clinicianLabel;
const named = (name) => {
    const trimmed = name?.trim();
    return trimmed === undefined || trimmed === "" ? null : trimmed;
};
/** The name to show: the F6 name for that ACO, TIN and NPI wins over the bundle's; null for neither. */
function preferredClinicianName(providerListName, bundleName) {
    return named(providerListName) ?? named(bundleName);
}
/** "Name (NPI)", or the NPI alone when the clinician has no name. */
function clinicianLabel(clinician) {
    const name = named(clinician.name);
    return name === null ? clinician.npi : `${name} (${clinician.npi})`;
}
//# sourceMappingURL=clinician.js.map